// extracted by mini-css-extract-plugin
module.exports = {"header":"e_Ho","gallery":"e_Io","label":"e_Jo"};